import React from 'react';
import { useSelector } from 'react-redux';
import { AuthEditContentContainer } from './AuthEditMain.css';

const FactoryInnerAuthEdit = ({ factoryAuths, register, inputAuth }) => {
  return (
    <AuthEditContentContainer>
      <div className="factory-auth-check-box">
        <span>소속공장</span>
        <select name="parentAuthIdx" ref={register({ validate: (value) => value !== '-1' })} defaultValue={inputAuth.parentAuth}>
          <option value={-1}>소속된 공장권한을 선택해주세요</option>
          {factoryAuths.map((auth) => {
            return <option value={auth.authIdx}>{auth.authNm}</option>;
          })}
        </select>
      </div>
    </AuthEditContentContainer>
  );
};

export default FactoryInnerAuthEdit;
